import * as services from '@services/index';
import { SkinPicVO } from '@/schemas/skin';
import { IDoctorInfo } from '@/schemas/doctor';

export interface base64 {
  base64: string;
  fileType: string;
  height: number;
  originFilePath: string;
  width: number;
} // 需要挪走
export interface IQuestionAnswer {
  order: string; // 问题序号
  answerTitle: string; // 问题title
  globalAnswers: string; // 答案
}

interface State {
  descriptionInfos: Array<IQuestionAnswer>; // 问题答案:给后端
  globalAnswers: Record<number, string>; // 问题答案:给前端渲染组件的数据
  skinPics: string[]; // 拍照测肤图片
  cdnSkinPics: SkinPicVO[];
  customOption: Record<string, string>; // 自定义选项内容，key：问题id-选项id
  fullTimeDoctors: IDoctorInfo[]; // 拍照测肤结果成功状态获取到的全职医生列表
}

const skin = {
  state: {
    skinPics: [],
    descriptionInfos: [] as Array<IQuestionAnswer>, // 问卷答案
    globalAnswers: {} as Record<number, string>, // 问卷答案:
    customOption: {} as Record<string, string>,
    fullTimeDoctors: [] as IDoctorInfo[]
  },

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    },
    updateSkinPics(state: State, payload: base64[]) {
      // let newSkinPic;
      // if (payload && payload?.length !== 0) {
      //   const pic = payload[0];
      //   newSkinPic = `data:image/${pic.fileType};base64, ${pic.base64}`;
      // }
      if (state.skinPics.length >= 9) return state;
      const newSkinPic = payload.map(
        (item) => `data:image/${item.fileType};base64, ${item.base64}`
      );
      if (newSkinPic) {
        return {
          ...state,
          skinPics: [...state.skinPics, ...newSkinPic]
        };
      }
      return state;
    },
    updateDescriptionInfos(state: State, payload: Array<IQuestionAnswer> | []) {
      return {
        ...state,
        descriptionInfos: payload
      };
    },
    updateGlobalAnswers(state: State, payload: Record<number, string>) {
      return {
        ...state,
        globalAnswers: payload
      };
    },
    clearDetectionData(state: State) {
      return {
        ...state,
        skinPics: [],
        descriptionInfos: [],
        globalAnswers: {},
        customOption: {}
      };
    },
    updateCustomOption(state: State, payload: Record<string, string>) {
      return {
        ...state,
        customOption: payload
      };
    }
  },

  effects: (dispatch) => ({
    async uploadSkinPics(state) {
      const { skinPics } = state.skinPic;
      try {
        const res = await services.skin.uploadSkinPics({ bases64: skinPics });
        this.updateState({
          cdnSkinPics: res
        });
      } catch (err) {
        //
      }
    }
  })
};

export default skin;
